import { createSlice, current } from '@reduxjs/toolkit';
import {
	getFiscalYearList,
	getFiscalYearById,
	addFiscalYearWithPeriods,
	updateFiscalYear,
	deleteFiscalYear,
} from './thunk';

export const initialState = {
	fiscalYearList: [],
	fiscalYear: null,
	isLoading: false,
	isSuccess: false,
	isError: false,
	error: null,
};

const fiscalYearSlice = createSlice({
	name: 'FiscalYear',
	initialState,
	reducers: {},
	extraReducers: builder => {
		// getFiscalYearList
		builder.addCase(getFiscalYearList.pending, state => {
			state.isLoading = true;
		});
		builder.addCase(getFiscalYearList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;
			state.fiscalYearList = action.payload;
		});
		builder.addCase(getFiscalYearList.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.error.message;
		});

		// getFiscalYearById
		builder.addCase(getFiscalYearById.pending, state => {
			state.isLoading = true;
		});
		builder.addCase(getFiscalYearById.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;
			state.fiscalYear = action.payload;
		});
		builder.addCase(getFiscalYearById.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.error.message;
		});

		// addFiscalYearWithPeriods
		builder.addCase(addFiscalYearWithPeriods.pending, state => {
			state.isLoading = true;
		});
		builder.addCase(addFiscalYearWithPeriods.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;
			state.fiscalYearList.push(action.payload);
		});
		builder.addCase(addFiscalYearWithPeriods.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.error.message;
		});

		// updateFiscalYear
		builder.addCase(updateFiscalYear.pending, state => {
			state.isLoading = true;
		});
		builder.addCase(updateFiscalYear.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;
			state.fiscalYearList = state.fiscalYearList.map(item =>
				item._id === action.payload._id
					? { ...item, ...action.payload }
					: item
			);
		});
		builder.addCase(updateFiscalYear.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.error.message;
		});

		// deleteFiscalYear
		builder.addCase(deleteFiscalYear.pending, state => {
			state.isLoading = true;
		});
		builder.addCase(deleteFiscalYear.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;
			state.fiscalYearList = state.fiscalYearList.filter(
				item =>
					item._id.toString() !== action.payload.fiscalYear._id.toString()
			);
		});
		builder.addCase(deleteFiscalYear.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.error.message;
		});
	},
});

export default fiscalYearSlice.reducer;
